/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import Loading from "vux/src/components/loading/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import Icon from "vux/src/components/icon/index.vue"; // this line is trasformed by vux-loader
import { baseUrl } from '@root/_target.js';
import FileVideoUpload from '@/components/CustomFormList/FileVideoUpload.vue';
export default {
  name: 'FileUpload',
  components: {
    FileVideoUpload: FileVideoUpload,
    Loading: Loading,
    Icon: Icon
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    title: {
      type: String,
      default: i18n.tc("384")
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    num: {
      type: Number,
      default: 9
    },
    hiddenBorder: {
      type: Boolean,
      default: false
    },
    target: {
      type: String,
      default: '/upload/save'
    },
    action: {
      type: String,
      default: 'POST'
    },
    oss: {
      type: Boolean,
      default: false
    },
    showUpload: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      currValue: this.value,
      hasTitleSlot: false,
      loadingShow: false,
      progress: 0
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['config'])), {}, {
    realtarget: function realtarget() {
      return baseUrl + this.target;
    },
    imgUrlsForPreviewer: function imgUrlsForPreviewer() {
      var _this = this;
      return this.currValue.map(function (item) {
        var v = item.split('/');
        var name = _this.translate(v[v.length - 1]);
        return {
          url: item,
          name: name
        };
      });
    },
    isUpperLimit: function isUpperLimit() {
      return this.currValue.length === this.num;
    }
  }),
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    currValue: function currValue(val) {
      this.$emit('on-change', val);
      this.$emit('input', val);
    }
  },
  methods: {
    translate: function translate(str) {
      return str.slice(str.indexOf('-') + 1);
    },
    start: function start(e) {
      this.loadingShow = true;
    },
    finish: function finish(e) {
      console.log('AutoConsole: finish -> e', e);
      this.loadingShow = false;
      var res = e.data;
      if (res.success) {
        this.currValue = this.currValue.concat(res.data.fileUrl + (this.oss ? decodeURIComponent(res.data.files) : res.data.files));
      } else {
        this.$vux.toast.text(res.message);
      }
    },
    clickUpload: function clickUpload() {
      this.$vux.toast.text("\u6587\u4EF6\u6700\u591A".concat(this.num, i18n.tc("479")));
    },
    deleteImg: function deleteImg(index) {
      this.currValue.splice(index, 1);
    },
    show: function show(index) {
      var _this2 = this;
      this.$nextTick(function () {
        _this2.$refs['previewer'].show(index);
      });
    }
  },
  mounted: function mounted() {
    this.$slots.title && (this.hasTitleSlot = true);
  }
};